import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';
import { MessageService } from '@corelabs/angular/messages';
import { TranslateService } from '@ngx-translate/core';

export const notFound = (): RedirectFunction => {
    return () => {
        const messageService = inject(MessageService);
        const translateService = inject(TranslateService);
        const router = inject(Router);

        messageService.add(translateService.instant('error.not-found'), 'warning');

        return router.createUrlTree(['/', 'mode']);
    };
};
